// File: src/pages/ChatBotAdmin.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config/config';
import AdminPageFrame from "../components/admin/AdminPageFrame";

const ChatBotAdmin = () => {
  const [logs, setLogs] = useState([]);
  const [filterLang, setFilterLang] = useState('');
  const [filterIntent, setFilterIntent] = useState('');

  const fetchLogs = () => {
    axios.get(`${config.API_BASE_URL}/api/chatbot-logs`)
      .then((res) => setLogs(res.data))
      .catch((err) => console.error("Fehler beim Laden der Chatbot-Logs:", err));
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const filteredLogs = logs.filter(log => {
    return (
      (filterLang ? log.lang === filterLang : true) &&
      (filterIntent ? log.intent === filterIntent : true)
    );
  });

  return (
    <AdminPageFrame
      title="Chatbot Logs"
      subtitle="Operative Sicht auf Elena-Konversationen, Sprachen und Intent-Muster."
      badge="Chatbot Operations"
    >
      <div className="space-y-4">
        <div className="flex flex-wrap gap-4">
          <select
            value={filterLang}
            onChange={(e) => setFilterLang(e.target.value)}
            className="p-2 rounded bg-white text-black"
          >
            <option value="">Sprache: Alle</option>
            <option value="de">Deutsch</option>
            <option value="en">Englisch</option>
            <option value="fr">Franzoesisch</option>
            <option value="ar">Arabisch</option>
          </select>
          <select
            value={filterIntent}
            onChange={(e) => setFilterIntent(e.target.value)}
            className="p-2 rounded bg-white text-black"
          >
            <option value="">Thema: Alle</option>
            <option value="registration">Registrierung</option>
            <option value="visa">Visum</option>
            <option value="language">Sprache</option>
            <option value="platform">Plattform</option>
            <option value="recognition">Anerkennung</option>
            <option value="general">Allgemein</option>
          </select>
        </div>

        <table className="w-full text-sm text-left text-white border border-cyan-800">
          <thead className="text-xs uppercase bg-cyan-900 text-cyan-300">
            <tr>
              <th className="px-4 py-2">Zeit</th>
              <th className="px-4 py-2">Sprache</th>
              <th className="px-4 py-2">Intent</th>
              <th className="px-4 py-2">Frage</th>
              <th className="px-4 py-2">Antwort</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((log, index) => (
              <tr key={index} className="border-t border-cyan-800 hover:bg-cyan-800/20">
                <td className="px-4 py-2 whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</td>
                <td className="px-4 py-2">{log.lang}</td>
                <td className="px-4 py-2">{log.intent}</td>
                <td className="px-4 py-2 max-w-xs truncate">{log.question}</td>
                <td className="px-4 py-2 max-w-md truncate">{log.answer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminPageFrame>
  );
};

export default ChatBotAdmin;
